import once from "lodash/once";

//#region Types
interface IAppleID {
  auth: IAppleAuthID;
}

interface IAppleAuthID {
  init(config: { clientId: string; scope: string; redirectURI: string; state: string }): void;
  signIn(): void;
  renderButton(): void;
}

declare var AppleID: IAppleID | void;
//#endregion

export const loadAppleId = once(function loadApple() {
  return new Promise<IAppleID>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    script.async = true;
    script.onerror = reject;
    script.onload = () => {
      if (typeof AppleID === "undefined") {
        reject(new ReferenceError("AppleID doesn't exist in the global scope"));
      } else {
        resolve(AppleID);
      }
    };

    if (document.head) {
      document.head.appendChild(script);
    } else {
      throw new TypeError("loadApple(): document.head isn't declared");
    }
  });
});
